<template>
  <div class="ui container">
    <h2
      class="ui centered header"
      style="padding-top: 10px; padding-bottom: 10px"
    >
      <img src="/images/icons/staff_rating.png" />
      <div class="content">
        {{ $t("staff rating") }}
        <div class="sub header">{{ $t("module command center") }}</div>
      </div>
    </h2>
    <div class="ui four link cards">
      <div class="card" @click="go_templates">
        <div class="content">
          <h3 class="ui icon header" style="margin-bottom: 0">
            <img src="/images/icons/template.png" class="ui image" />
            <div class="content" style="margin-top: 8px">
              {{ $t("rating templates") }}
            </div>
          </h3>
        </div>
      </div>
      <div class="card" @click="go_organization">
        <div class="content">
          <h3 class="ui icon header" style="margin-bottom: 0">
            <img src="/images/icons/tree_management.png" class="ui image" />
            <div class="content" style="margin-top: 8px">
              {{ $t("360 organizational diagrams") }}
            </div>
          </h3>
        </div>
      </div>
      <div class="card" @click="go_teacher_organization">
        <div class="content">
          <h3 class="ui icon header" style="margin-bottom: 0">
            <img
              src="/images/icons/teacher_organizational_diagram.png"
              class="ui image"
            />
            <div class="content" style="margin-top: 8px">
              {{ $t("teacher organizational diagrams") }}
            </div>
          </h3>
        </div>
      </div>
      <div class="card" @click="go_360">
        <div class="content">
          <h3 class="ui icon header" style="margin-bottom: 0">
            <img src="/images/icons/360_feedback_2.png" class="ui image" />
            <div class="content" style="margin-top: 8px">
              {{ $t("360 evaluation management") }}
            </div>
          </h3>
        </div>
      </div>
      <!-- <div class="card" @click="go_teacher">
        <div class="content">
          <h3 class="ui icon header" style="margin-bottom:0">
            <img src="/images/icons/teacher_rating.png" class="ui image" />
            <div class="content" style="margin-top:8px">
              {{ $t("teacher rating") }}
            </div>
          </h3>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import filters from "@/filters";

export default {
  name: "Feedback360Index",
  components: {},
  filters: filters,
  data() {
    return {};
  },
  computed: {},
  methods: {
    go_templates() {
      let vm = this;
      vm.$router.push({ name: "StaffRatingTemplateIndex" });
    },
    go_organization() {
      let vm = this;
      vm.$router.push({ name: "StaffRatingOrganizationIndex" });
    },
    go_teacher_organization() {
      let vm = this;
      vm.$router.push({ name: "StaffRatingTeacherOrganizationIndex" });
    },
    go_360() {
      let vm = this;
      vm.$router.push({ name: "StaffRating360FeedbackIndex" });
    },
    go_teacher() {
      let vm = this;
      vm.$router.push({ name: "StaffRatingTeacherIndex" });
    },
  },
  mounted() {},
  watch: {},
};
</script>

<style></style>
